import { Component, OnInit } from '@angular/core';
import { IAmiHead } from 'src/app/@amiga-pyme/components/ami-head/ami-head.interface';
import { TableActionsTemplate } from 'src/app/@amiga-pyme/table-actions/templates/table-actions.template';
import { CashRegisterService } from '../../cash-register.service';
import { getTagColor } from 'src/helpers/tag-color.helpers';

@Component({
  selector: 'app-cash-register-document',
  templateUrl: './cash-register-document.component.html'
})
export class CashRegisterDocumentComponent extends TableActionsTemplate{

  settingsAmiHead: IAmiHead = {
    title: 'Caja Registradora',
    addressImg: 'reports'
  };

  constructor(
    private serviceBase: CashRegisterService
  ) { 
    super('', serviceBase);
  }

  ngOnInit(): void {
    this.table.settings = {
      title: 'Reporte de caja registradora',
      columns: [
        { header: 'Sucursal', field: 'branchStoreName' },
        { header: 'Usuario', field: 'userName' },
        { header: 'Fecha apertura', field: 'openingDate' },
        { header: 'Fecha cierre', field: 'closingDate' },
        { header: 'Saldo inicial', field: 'initialBalance', pipe: 'Currency' },
        { header: 'Ventas al contado', field: 'cashSales', pipe: 'Currency' },
        { header: 'Saldo en caja', field: 'balance', pipe: 'Currency' },
        { header: 'Saldo de caja real', field: 'endingBalance', pipe: 'Currency' },
        { header: 'Estado', field: 'status', tag: 'tagStatus'}
      ],
      exportData: true,
      filterColumns: true
    };
    
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: any[]) => {
        data = data.map((item) => {
          item.tagStatusColor = getTagColor(item.status);
          return item;
        });

        this.table.data = data;
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }

}
